<div class="parent-column-header">
  <div class="header-container pointer" #connectedEl (click)="toggleMenu()">
    <div class="header-icon">
      <app-icon [phosphorClass]="icon!" [color]="iconColor" [size]="Size.small"></app-icon>
      @if (activeFiltersNumber) {
        <app-badge-notification class="badge" [value]="activeFiltersNumber"></app-badge-notification>
      }
    </div>
    <span>{{ name }}</span>
  </div>

  @if (menuVisible && type === 'filter') {
    <div class="filter-container-drop">
      @for (item of filterItems; track item) {
        <div class="filter" (click)="onFilterItemClick(item)" tabindex="0" role="button">
          <div class="filter-item">
            <app-checkbox (checkedChange)="onFilterItemClick(item)" [checked]="item.checked"></app-checkbox>
            <span>{{ filterTranslate ? filterTranslate(item.name) : (item.name | titlecase) }}</span>
          </div>
        </div>
      }
    </div>
  }
</div>
